// eslint-disable-next-line
import * as React from 'react';
import Linkify from "linkify-react";


type Props = {
    label: string;
    values: string[];
}


// ------------------------------------------------------------------------------------------------
// component

class BpiDetailsTableRow extends React.Component<Props> {

    // --------------------------------------------------------------------------------------------
    // render

    renderValueWithBreaks(value) {
        return value.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index < value.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    }

    public render() {
        return (
            <tr>
                <th> <p> {this.props.label} </p> </th>
                <td>
                    {this.props.values && this.props.values.map(
                        (value, index) =>
                        <Linkify as="p" key={index}> {this.renderValueWithBreaks(value)} </Linkify>
                    )}
                </td>
            </tr>
        )
    }
};



export default BpiDetailsTableRow;